export interface ServiceData {
  name: string;
  slug: string;
  description: string;
  features: string[];
  imageUrl: string;
  mainImageUrl: string;
  additionalInfo?: string;
}

export const SERVICES_DATA: Record<string, ServiceData> = {
  "home-repairs": {
    name: "Home Repairs",
    slug: "home-repairs",
    description:
      "Keep your home in top condition with Brin's Handyman Services. We handle all types of home repairs, from fixing leaky faucets to patching up drywall, ensuring your home stays safe and functional. No job is too big or small, and each repair is done with quality and care.",
    features: [
      "Leaky Faucet Repair",
      "Door & Window Fixes",
      "Cabinet Adjustments",
      "Light Fixture Installation",
      "Hardware Replacement",
      "General Maintenance",
    ],
    imageUrl: require("../assets/services/home-repairs.jpg"),
    mainImageUrl: require("../assets/services/home-repairs-main.jpg"),
    additionalInfo:
      "Our experienced handyman team is equipped to handle a wide range of home repair tasks. We understand that every home is unique, which is why we provide personalized solutions tailored to your specific needs. From minor touch-ups to major repairs, we ensure your home remains a safe and comfortable place for you and your family.",
  },
  painting: {
    name: "Painting",
    slug: "painting",
    description:
      "Transform your space with professional painting services from Brin's Handyman Services. Whether it's a single room or your entire home, we provide meticulous and high-quality painting, ensuring a fresh and vibrant look for your interiors and exteriors.",
    features: [
      "Interior Painting",
      "Exterior Painting",
      "Color Consultation",
      "Surface Preparation",
      "Priming & Sealing",
      "Touch-ups & Repairs",
    ],
    imageUrl: require("../assets/services/painting.jpg"),
    mainImageUrl: require("../assets/services/painting-main.jpg"),
    additionalInfo:
      "We use only premium quality paints and materials to ensure long-lasting results. Our team takes pride in attention to detail, from proper surface preparation to clean, professional finishes. Whether you're looking to refresh a single room or give your entire home a makeover, we'll help you achieve the perfect look.",
  },
  "drywall-installation-and-repair": {
    name: "Drywall Installation and Repair",
    slug: "drywall-installation-and-repair",
    description:
      "Enhance your home with expert drywall installation and repair from Brin's Handyman Services. Whether you need new drywall installed or existing walls repaired, we ensure seamless and professional results, leaving your walls smooth and ready for painting or finishing.",
    features: [
      "New Drywall Installation",
      "Drywall Repair & Patching",
      "Taping & Mudding",
      "Sanding & Finishing",
      "Texture Matching",
      "Hole & Crack Repair",
    ],
    imageUrl: require("../assets/services/drywall.jpg"),
    mainImageUrl: require("../assets/services/drywall-main.jpg"),
    additionalInfo:
      "Our skilled craftsmen have years of experience in drywall work, ensuring that every installation and repair meets the highest standards. We handle everything from small patches to complete room renovations, always maintaining a clean work environment and delivering results that blend seamlessly with your existing walls.",
  },
  "plumbing-and-pipes": {
    name: "Plumbing & Pipes",
    slug: "plumbing-and-pipes",
    description:
      "Ensure your plumbing is in perfect working order with Brin's Handyman Services. We handle everything from fixing leaks and unclogging drains to installing new pipes, providing reliable and efficient plumbing solutions for your home. For complex plumbing work requiring licensed professionals, we collaborate with certified plumbers to ensure all work meets local codes and regulations.",
    features: [
      "Leak Detection & Repair",
      "Drain Cleaning & Unclogging",
      "Pipe Installation",
      "Faucet & Fixture Repair",
      "Toilet Repairs",
      "Water Heater Service",
    ],
    imageUrl: require("../assets/services/plumbing.jpg"),
    mainImageUrl: require("../assets/services/plumbing-main.jpg"),
    additionalInfo:
      "Our plumbing services are designed to keep your home's water systems running smoothly. We use modern tools and techniques to diagnose and fix plumbing issues quickly and efficiently. For work requiring licensed plumbers (such as major installations, gas line work, or code-regulated projects), we partner with certified professionals to ensure compliance with all local regulations and safety standards. From emergency repairs to planned installations, we ensure minimal disruption to your daily routine while delivering lasting solutions.",
  },
  carpentry: {
    name: "Carpentry",
    slug: "carpentry",
    description:
      "Add quality and craftsmanship to your home with Brin's Handyman Services. We offer a range of carpentry services, including custom shelves, cabinetry, and repairs, ensuring precision and attention to detail in every project.",
    features: [
      "Custom Shelving",
      "Cabinet Installation",
      "Trim & Molding",
      "Door Installation",
      "Custom Built-ins",
      "Wood Repairs",
    ],
    imageUrl: require("../assets/services/carpentry.jpg"),
    mainImageUrl: require("../assets/services/carpentry-main.jpg"),
    additionalInfo:
      "Our carpentry work combines traditional craftsmanship with modern techniques to create beautiful, functional solutions for your home. Whether you need custom storage solutions, decorative trim work, or structural repairs, we bring years of experience and attention to detail to every project.",
  },
  "furniture-repairs": {
    name: "Furniture Repairs",
    slug: "furniture-repairs",
    description:
      "Restore your furniture to its original beauty with Brin's Handyman Services. We provide expert repairs for all types of furniture, from fixing broken legs to refinishing surfaces, ensuring your pieces are sturdy and look their best.",
    features: [
      "Broken Leg Repair",
      "Drawer & Hardware Fixes",
      "Surface Refinishing",
      "Upholstery Repairs",
      "Structural Reinforcement",
      "Antique Restoration",
    ],
    imageUrl: require("../assets/services/furniture-repairs.jpg"),
    mainImageUrl: require("../assets/services/furniture-repairs-main.jpg"),
    additionalInfo:
      "We understand the sentimental and monetary value of your furniture pieces. Our skilled craftsmen take great care in restoring your furniture to its former glory, using appropriate techniques and materials for each type of piece. From family heirlooms to modern furniture, we treat every repair with the respect and attention it deserves.",
  },
};
